<template>
    <div class="container">
        <ConfirmPortfolio
            v-if="portfolio && !manualInvestment"
            :selectedPortfolio="portfolio"
            :isCreatePortfolio="false"
            :hidePlan="true"
            @success="redirectToDashboard"
            @insufficientFunds="insufficientFunds"
        />
        <ConfirmManualInvestment
            v-else-if="!portfolio && manualInvestment"
            :selection="manualInvestment"
            @success="redirectToLoans"
        />
        <v-snackbar
            v-model="isInsufficientFunds"
            app
            timeout="-1"
        >
            Your Escrow Balance has insufficient funds!
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isInsufficientFunds = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import ConfirmPortfolio from '../common/confirmPortfolio.vue'
import ConfirmManualInvestment from '../common/confirmManualInvestment.vue'
export default {
    name: 'Wallet',
    props: {
        portfolio: Object,
        manualInvestment: Object
    },
    components: {
        ConfirmPortfolio,
        ConfirmManualInvestment
    },
    data () {
        return {
            isInsufficientFunds: false
        }
    },
    methods: {
        redirectToDashboard () {
            this.$router.push('/dashboard')
        },
        redirectToLoans () {
            this.$router.replace('/loans')
        },
        insufficientFunds () {
            this.isInsufficientFunds = true
        }
    }
}
</script>
